import React, { useContext } from "react";
import DoctorHistorySummary from "../../InspectionSummaries/HistorySummary/DoctorHistorySummary";
import DrGeneralExaminationSummary from "../../InspectionSummaries/GeneralExaminationSummary/DrGeneralExaminationSummary";
import DrSystemicExaminationSummary from "../../InspectionSummaries/SystemicExaminationSummary/DrSystemicExaminationSummary";
import { DoctorInitialContext } from "../../InspectionForms/HistoryForm/DoctorHistoryFormProvider";
import { Col, Row, Tag } from "antd";
import DrFunctionalExaminationSummary from "../../InspectionSummaries/FunctionalExaminationSummary/DrFunctionalExaminationSummary";
import DrClinicalImpressionSummary from "../../InspectionSummaries/ClinicalImpressionSummary/DrClinicalImpressionSummary";
import "../../summary.css";
import { checkEmpty } from "../../../../helpers/utility";
import dayjs from "dayjs";

const InitialInspectionSummary = () => {
  const { formData } = useContext(DoctorInitialContext);

  return (
    <Row className="summaries" gutter={[8, 12]}>
      <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={12}>
        {checkEmpty(formData?.history) && (
          <DoctorHistorySummary formData={formData} />
        )}
        {checkEmpty(formData?.systemic_examination) && (
          <DrSystemicExaminationSummary />
        )}
      </Col>
      <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={12}>
        {checkEmpty(formData?.general_examination) && (
          <DrGeneralExaminationSummary />
        )}

        {checkEmpty(formData?.clinical_diagnosis) && (
          <DrClinicalImpressionSummary context={DoctorInitialContext} />
        )}
        {checkEmpty(formData?.functional_examination) && (
          <DrFunctionalExaminationSummary />
        )}
      </Col>
    </Row>
  );
};

export default InitialInspectionSummary;
